import { FormatTypes } from '@constants/templateDictionaries';

export const checkNodes = {
  personalInfoNode: ['fullName', 'email', 'phoneNumber', 'address'],
  skillsNode: ['skill'],
  workExperienceNode: ['name', 'date', 'description', 'jobTitle'],
  educationNode: ['name', 'location', 'degree', 'fieldOfStudy'],
  awardsAndHonorsNode: ['description'],
  certificationsNode: ['title', 'date', 'description'],
  coursesNode: ['title', 'date', 'description'],
  projectsNode: ['description', 'date', 'title'],
  summaryNode: ['summary'],
  volunteerWorkNode: ['description'],
  patentsNode: [
    'description',
    'date',
    'title',
    'status',
    'url',
    'patentId',
    'country',
  ],
  publicationsNode: ['publications'],
  leadershipNode: ['name', 'description'],
  conferencesNode: ['description'],
  associationsNode: ['description'],
  coverLetterNode: [
    'receiverInfo',
    'subjectLine',
    'openGreeting',
    'letterBody',
    'personalInfo',
  ],
};

export const mapJdPopUp = {
  'High School': 'high_school',
  Undergraduate: 'undergrad',
  Graduate: 'grad',
  '1-5 yrs Exp': '1-5',
  '5+ yrs Exp': '5+',
};

export const mapReduxToJdPopUp = {
  high_school: 'High School',
  undergrad: 'Undergraduate',
  grad: 'Graduate',
  '1-5': '1-5 yrs Exp',
  '5+': '5+ yrs Exp',
};

export const printSectionKey = {
  skills: 'Skills',
  workExperience: 'Work Experience',
  personalInfo: 'Personal Info',
  education: 'Education',
  summary: 'Summary',
  awardsAndHonors: 'Awards & Honors',
  projects: 'Projects',
  courses: 'Courses',
  certifications: 'Certifications',
  patents: 'Patents',
  publications: 'Publications',
  volunteerWork: 'Volunteer Work',
  leadership: 'Leadership',
  conferences: 'Conferences/Presentations',
  associations: 'Associations',
  coverLetter: 'Cover Letter',
  researchExperience: 'Research Experience',
  extraCurricular: 'Extra Curricular Activities',
};

export const printNodes = {
  personalInfo_fullName: 'Name',
  personalInfo_email: 'Email',
  personalInfo_phoneNumber: 'Phone Number',
  personalInfo_address: 'Address',
  skills_skill: 'Skills',
  workExperience_name: 'Organization Name',
  workExperience_date: 'Date',
  workExperience_description: 'Role Description',
  education_name: 'Institution  Name',
  education_location: 'Institution  Address',
  education_degree: 'Degree',
  awardsAndHonors_description: 'Description',
  certifications_description: 'Certificate Details',
  certifications_date: 'Date',
  courses_description: 'Description',
  projects_description: 'Description',
  projects_url: 'Associated URL',
  projects_date: 'Date',
  summary_summary: 'Summary',
  volunteerWork_description: 'Description',
  patents_title: 'Title',
  patents_description: 'Description',
  publications_publications: 'Publications',
  leadership_name: 'Organization Name',
  leadership_description: 'Description',
  conferences_description: 'Description',
  associations_description: 'Description',
  coverLetter_personalInfo: 'Personal Info',
  coverLetter_receiverInfo: 'Receiver Info',
  coverLetter_subjectLine: 'Subject Line',
  coverLetter_openGreeting: 'Greeting',
  coverLetter_letterBody: 'Letter Body',
};

export const nodeType = {
  PARAGRAPH: 'paragraph',
  PARAGRAPH_LINKS: 'paragraphWithLink',
  ACCORDION: 'accordion',
  CARD: 'card',
};

export const sectionKeyName = {
  PERSONAL_INFO: 'personalInfo',
  EMAIL_AND_PHONE_NUMBER: 'emailAndPhoneNumber',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  FULL_NAME: 'fullName',
  TAGLINE: 'tagline',
  ADDRESS: 'address',
  RECEIVER_INFO: 'receiverInfo',
  PERSONAL_LINKS: 'personalLinks',
};

export const MessageSvg = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const MessageCommentType = {
  ORDERED_LIST: 'ordered_list',
  UNORDERED_LIST: 'unOrdered_list',
};

export const MessageButtonType = {
  CONSENT: 'consent',
};

export const skillTypes = {
  TECHNICAL_SKILLS_HEADING: 'technicalSkillsHeading',
  SOFT_SKILLS_HEADING: 'softSkillsHeading',
  MATCHED: 'matched',
  UNMATCHED: 'unmatched',
};

export const sectionKeys = [
  'languages',
  'references',
  'testScores',
  'hobbiesAndInterests',
];

export const NoOfButtons = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
];

export const TetraButtonTexts = {
  EVALUATING: 'Evaluating...',
  EVALUATED: 'Evaluated',
  RUN_EVALUATE: 'Evaluate',
  CONFIRMING: 'Confirming...',
  FIX_ALL_ERRORS: 'Fix All Errors',
  [`${FormatTypes.RESUME}_SCORE`]: 'Resume Score',
  [`${FormatTypes.COVER_LETTER}_SCORE`]: 'Cover Letter Score',
  SECTION_SCORE: 'Section Score',
};

export const SECTION_TIPS = 'Section Tips';
export const DETAILED_SCAN = 'Detailed Scan';
export const TETRA_TOGGLE = 'TetraToggle';
export const ADD_JD = '+ Add Job Desc.';
export const INCORRECT = 'Incorrect: ';
export const CORRECT = 'Correct: ';
export const COVER_LETTER_SECTION_KEY = 'coverLetter';
export const ADD_EXPERIENCE = 'Edit Experience';
export const TETRA_VERSIONS = {
  V1: 'v1',
};

export const DATE_NODE = 'date';

export const nodeTypes = {
  personalInfo_fullName: 'full_name',
  personalInfo_phoneNumber: 'phone_number',
  personalInfo_email: 'email',
  personalInfo_address: 'address',
  personalInfo_personalLinks: 'personal_link',
  skills_skill: 'skill_title',
  workExperience_name: 'work_experience_organization_name',
  workExperience_date: 'work_experience_date',
  workExperience_description: 'work_experience_role_description',
  workExperience_jobTitle: 'work_experience_job_title',
  workExperience_from: 'work_experience_from',
  workExperience_to: 'work_experience_to',
  education_name: 'education_organization_name',
  education_location: 'education_organization_address',
  education_degree: 'education_degree_title',
  education_date: 'education_date',
  education_from: 'education_from',
  education_to: 'education_to',
  education_fieldOfStudy: 'education_field_title',
  awardsAndHonors_description: 'awards_and_honors_award_description',
  awardsAndHonors_name: 'awards_and_honors_organization_name',
  awardsAndHonors_title: 'awards_and_honors_award_title',
  awardsAndHonors_date: 'awards_and_honors_issue_date',
  certifications_description: 'certifications_certification_description',
  certifications_title: 'certifications_certification_title',
  certifications_date: 'certifications_date',
  certifications_from: 'certifications_from',
  certifications_to: 'certifications_to',
  courses_description: 'courses_course_description',
  projects_description: 'projects_project_description',
  projects_url: 'projects_url_title',
  projects_date: 'projects_project_date',
  projects_title: 'projects_project_title',
  projects_from: 'projects_from',
  projects_to: 'projects_to',
  courses_title: 'courses_course_title',
  courses_date: 'courses_completion_date',
  summary_summary: 'summary',
  volunteerWork_name: 'volunteer_work_organization_name',
  volunteerWork_title: 'volunteer_work_role_title',
  volunteerWork_cause: 'volunteer_work_cause_title',
  volunteerWork_date: 'volunteer_work_date',
  volunteerWork_description: 'volunteer_work_role_description',
  patents_title: 'patents_patent_title',
  patents_date: 'patents_patent_date',
  patents_status: 'patents_patent_status_title',
  patents_country: 'patents_patent_country_title',
  patents_patentId: 'patents_patent_id_title',
  patents_url: 'patents_patent_url_title',
  patents_description: 'patents_patent_description',
  publications_publications: 'publication_tetra',
  leadership_name: 'leadership_organization_name',
  leadership_title: 'leadership_role_title',
  leadership_date: 'leadership_date',
  leadership_description: 'leadership_role_description',
  conferences_description: 'conferences_conference_description',
  conferences_title: 'conferences_conference_title',
  conferences_name: 'conferences_organization_name',
  conferences_date: 'conferences_date',
  associations_description: 'associations_association_description',
  associations_name: 'associations_organization_name',
  associations_title: 'associations_association_title',
  associations_url: 'associations_url_title',
  associations_date: 'associations_date',
  extraCurricular_description: 'extra_curricular_activity_description',
  extraCurricular_name: 'extra_curricular_organization_name',
  extraCurricular_title: 'extra_curricular_activity_title',
  extraCurricular_url: 'extra_curricular_url_title',
  extraCurricular_date: 'extra_curricular_date',
  researchExperience_title: 'research_experience_research_title',
  researchExperience_date: 'research_experience_research_date',
  researchExperience_description: 'research_experience_research_description',
  coverLetter_personalInfo: 'coverLetter_personalInfo_tetra',
  coverLetter_receiverInfo: 'coverLetter_receiverInfo_tetra',
  coverLetter_subjectLine: 'subject_line',
  coverLetter_openGreeting: 'coverLetter_openGreeting_tetra',
  coverLetter_letterBody: 'coverLetter_letterBody_tetra',
  coverLetter_personalLinks: 'personal_link',
};

export const coverLetterNodes = {
  receiverInfo: 'receiverInfo',
  subjectLine: 'subjectLine',
  openGreeting: 'openGreeting',
  letterBody: 'letterBody',
  personalInfo: 'personalInfo',
};

export const INPUT_PATH = 'inputPath';

export const TETRA_FIX_TYPES = {
  SKILLS_SEQUENCE: 'skillsSequence',
};
